/**
 * Fetches graduates via Welcome.php on server.abiatechhub.com (API key stays server-side).
 */

const API_BASE = 'https://server.abiatechhub.com';

async function graduatesFetch(path, params = {}) {
    const url = new URL(`${API_BASE}/graduates${path}`);
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            url.searchParams.set(key, String(value));
        }
    });

    const res = await fetch(url.toString(), {
        headers: { Accept: 'application/json' },
    });

    if (res.status === 404) {
        return null;
    }

    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.message || `Graduates API error: ${res.status}`);
    }

    return res.json();
}

export async function fetchPublishedGraduates(params = {}) {
    try {
        const json = await graduatesFetch('', {
            q: params.q,
            skill: params.skill,
            available_only: params.available_only ? '1' : undefined,
        });
        return json?.data ?? [];
    } catch (e) {
        console.warn('Graduates list API unavailable:', e.message);
        return [];
    }
}

export async function fetchGraduateBySlug(slug) {
    if (!slug) return null;
    try {
        const json = await graduatesFetch(`/${encodeURIComponent(slug)}`);
        return json?.data ?? null;
    } catch (e) {
        console.warn('Graduate detail API unavailable:', e.message);
        return null;
    }
}
